export default __webpack_public_path__ + "static/media/Ubuntu-Regular.fbdecfce.ttf";